export const CROWS_SEARCH_ADJUSTMENTS = 5248;
export const TEST_GROUP = 2;

export const MAX_RECENT = 2;
export const MAX_SUGGESTION_ROWS = 6;
export const MAX_TRENDING = 9;
export const MAX_QUICK_FILTERS = 4;
export const TYPING_INTERVAL_MS = 40;
export const TYPING_HOLD_MS = 3000;
export const REVEAL_BASE_DELAY_MS = 80;
export const REVEAL_STAGGER_MS = 40;
